module.exports = __webpack_public_path__ + "media/Wir.2f60e1a9.mp3";